import {
    TModoGestaoAtendimento,
    IAtendimentoRepasseRequest,
    IListarRepasseResponse,
} from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosRepasse(
    requestBody: IAtendimentoRepasseRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    todos?: boolean
) {
    return Service(
        Axios.post<IListarRepasseResponse>(
            `/repasse/atendimentosrepasse/listaratendimentos?ID_PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&todos=${
                todos ?? false
            }`,
            requestBody
        )
    );
}
